import qs from '@scoir/query-string'

import { EVENT_CLICK_SOURCES } from 'common/track-event-constants'

export const getSearchURL = (term: string) => {
  const url = `${import.meta.env.BASE_URL}/discover/posts`
  const queryString = qs.stringify({
    tag: encodeURI(term),
    source: EVENT_CLICK_SOURCES.TYPE_AHEAD_SEARCH,
  })
  return `${url}?${queryString}`
}
